import React from 'react';

import type { GridRenderCellParams, GridRenderEditCellParams } from '@mui/x-data-grid-premium';

import Box from '@mui/material/Box';
import QAmountField from 'components/QAmountField';

type Props = GridRenderCellParams & {
  showColor?: 'both' | 'negative' | 'positive';
  typographyProps?: object;
  expectedSign?: 'positive' | 'negative';
  fullWidth?: boolean;
  hideCurrency?: boolean;
  sx?: object;
};

export const QAmountFieldCell = (props: Props) => {
  const { showColor, typographyProps, value, expectedSign = 'positive', fullWidth = true, hideCurrency, sx } = props;

  return (
    <Box height='100%' display='flex' alignItems='center'>
      <QAmountField
        classes={{ input: 'MuiDataGrid-cellContent' }}
        expectedSign={expectedSign}
        fullWidth={fullWidth}
        hideCurrency={hideCurrency}
        plain
        removeSpacing
        showColor={showColor}
        typographyProps={typographyProps}
        value={value}
        sx={sx}
      />
    </Box>
  );
};

export const QAmountFieldEditCell = (props: GridRenderEditCellParams) => {
  const { api, id, field, value, expectedSign = 'positive', hideCurrency } = props;

  const handleValueChange = async ({ target: { value: newValue } }: any) => {
    api.setEditCellValue({
      id,
      field,
      value: newValue,
    });
  };

  return (
    <QAmountField
      autoFocus
      className='MuiDataGrid-editInputCell MuiDataGrid-cell--textRight'
      editable
      expectedSign={expectedSign}
      fullWidth
      hideCurrency={hideCurrency}
      onChange={handleValueChange}
      onSubmit={handleValueChange}
      plain
      removeSpacing
      value={value}
    />
  );
};
